import styled from 'styled-components'

export const Container = styled.div`
    margin: 100px 0 120px 0;
    display: flex;
    flex-direction: column;
    align-items: center;

    p {
        max-width: 550px;
        font-weight: 500;
        font-size: 16px;
        text-align: center;
        color: black;
        margin: 40px 0 60px 0;
    }
`
